import { createApp } from 'vue';
import cmpBtnFacebookLogin from '../vue/common/FacebookLoginButton.vue';
import cmpBtnGoogleLogin from '../vue/common/GoogleLoginButton.vue';
import cmpFormSignIn from '../vue/common/SignInForm.vue';

window.FacebookLoginButton = (function(){
	const component = createApp(cmpBtnFacebookLogin, {
		appId: window.FbAppId,
		version: window.FbVersion,
		urlRedirect: '/bundles/',
		width: 300
	});
	delete window.FbAppId;
	delete window.FbVersion;
	return component.mount('#component-button-facebook-login');
})();

window.GoogleLoginButton = (function(){
	const component = createApp(cmpBtnGoogleLogin, {
		clientId: window.GClientId,
		redirectUrl: '/bundles/',
		width: 300
	});
	delete window.GClientId;
	return component.mount('#component-button-google-login');

})();

window.SignInForm = (function(){
	var showLogin = (window?.ShowLogin ?? true) ? 'true' : 'false';
	const component = createApp(cmpFormSignIn, {
		redirectUrl: '/bundles/',
		showLogin: showLogin,
		width: 300
	});
	delete window.ShowLogin;
	return component.mount('#component-form-signin');
})();
